import React from "react";
import {
  Box,
  Card,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import JumboSearch from "@jumbo/components/JumboSearch";

/**
 * Toolbar pattern aligned with Access System vouchers-management:
 * search Card + add IconButton (left), flex spacer (center), optional right slot (e.g. Pagination).
 */
export function DsokManagementListToolbar({
  searchPage,
  onSearchChange,
  searchPlaceholder,
  addTooltip,
  onAddClick,
  addAriaLabel,
  rightSlot = null,
}) {
  return (
    <Stack
      direction="row"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      spacing={1}
    >
      <Box width="40%" display="flex" flexDirection="row">
        <Card sx={{ mb: 0, width: "100%", flex: 5 }}>
          <JumboSearch
            page={searchPage}
            onChange={onSearchChange}
            sx={{
              width: "100%",
            }}
            placeholder={searchPlaceholder}
          />
        </Card>
        <Tooltip title={addTooltip}>
          <IconButton
            onClick={onAddClick}
            {...(addAriaLabel != null ? { "aria-label": addAriaLabel } : {})}
          >
            <AddBoxIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ flex: 1, justifyContent: "center" }}
      />

      {rightSlot != null ? (
        rightSlot
      ) : (
        <DsokManagementListToolbarPaginationSpacer />
      )}
    </Stack>
  );
}

/**
 * Reserves space similar to MUI Pagination so layouts match vouchers-management when there is no pagination control.
 */
export function DsokManagementListToolbarPaginationSpacer() {
  return (
    <Box
      sx={{
        minWidth: { xs: 0, sm: 220 },
        minHeight: 40,
        flexShrink: 0,
      }}
    />
  );
}
